import { reorder } from 'utils/reorder';

export const reorderTagsArray = (tags: readonly string[]) =>
  tags.includes('Recap') ? reorder(tags, tags.indexOf('Recap'), 0) : tags;
